import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2ppngtaknh: FaireBrandEntity = {
  token: "b_2ppngtaknh",
  type: "brand",
  name: "Karma Wellness Kitchen",
  avatarUrl:
    "https://cdn.faire.com/fastly/382e095538b18288703b04e26cd9a97d6924e705b409d9bf9e67a650e130b5de.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3c1e6b825c88562890284e0fe865f37988f1f1b64d84b94c379cc4703a87bb1f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/382e095538b18288703b04e26cd9a97d6924e705b409d9bf9e67a650e130b5de.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3c1e6b825c88562890284e0fe865f37988f1f1b64d84b94c379cc4703a87bb1f.png",
  location: "Commerce Township, MI, USA",
  minimumOrderDollars: 25,
  rating: 5,
  reviewCount: 12,
  isTopShop: true,
  isInsider: true,
  description:
    "Karma Wellness Kitchen is a women-owned small business based in Michigan. Our vision is to have a healthy food future for everyone. To secure this vision, we have created healthy, plant-based food options for everyone. Our flagship product is a line of popped water lily seeds in five flavors. Popped water lily seeds are superfoods, high in protein. They can be eaten as a snack or used as a topping for other dishes. We offer one-pot, easy-to-cook Indian meal kits that are convenient and healthy for everyone. All our products are plant-based, gluten free, with clean ingredients.  At Karma, we truly believe in creating a sustainable healthy food future that’s good for our bodies and planet. ",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:06.139Z",
    importedBy: "entity-db-cli",
  },
};
